<bfx-text-input
  class="bfx-quick-search"
  #inputField
  [fieldStartContainer]="searchButton"
  fieldStartIcon="icon_ion_search_filled"
  [fieldEndIcon]="clearIconClass"
  [(ngModel)]="searchValue"
  (fieldIconClick)="onClearClick()"
  size="sm"
  [maxLength]="100"
  placeholder="Search"
  title="Quick filter"
></bfx-text-input>

<ng-template #searchButton>
  <i class="bfx-icon icon_ion_search_filled"></i>
</ng-template>
